import { render, staticRenderFns } from "./Iframe.global.vue?vue&type=template&id=fe8d4b12&scoped=true&lang=pug&"
import script from "./Iframe.global.vue?vue&type=script&lang=ts&"
export * from "./Iframe.global.vue?vue&type=script&lang=ts&"
import style0 from "./Iframe.global.vue?vue&type=style&index=0&id=fe8d4b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8d4b12",
  null
  
)

export default component.exports